import { useEffect, useState } from "react";

const useTheme = (): [string, (e: KeyboardEvent) => void, boolean] => {
  const [theme, setTheme] = useState("dark");
  const [mounted, setMounted] = useState(false);

  const setMode = (mode: string) => {
    window.localStorage.setItem("theme", mode);
    setTheme(mode);
  };

  const toggleTheme = (e: KeyboardEvent) => {
    if (e.metaKey) {
      setMode("girth");
    } else {
      if (theme === "dark") {
        setMode("dark");
      } else {
        setMode("dark");
      }
    }
  };

  useEffect(() => {
    const localTheme = window.localStorage.getItem("theme");

    !localTheme
      ? // window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches && !localTheme
        setMode("dark")
      : localTheme
      ? setTheme(localTheme)
      : setMode("dark");
    setMounted(true);
  }, []);

  return [theme, toggleTheme, mounted];
};

export default useTheme;
